import { useState } from "react";
import bg from "../assets/green-blurred-background.png";
import ReelLoader from "../components/LoadingReel";

const Main = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="main-container">
      {!imageLoaded && <ReelLoader />}
      <div className={`main-content ${imageLoaded ? "show" : "hide"}`}>
        <div className="main-blur-circle"></div>

        <div className="hero-text">
          <h1 className="hero-cinema">CINEMA</h1>
          <h1 className="hero-felice">FELICE</h1>
        </div>

        <img
          className="main-bg-img"
          src={bg}
          alt="floating-green-bubbles"
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)}
        />
      </div>
    </div>
  );
};

export default Main;
